<div class="portfolios-header display-flex align-items-center justify-content-space-between">
  <ng-content></ng-content>
</div>
